@if (pois().length > 0) {
  <p class="font-bold mb-1">{{ translation.navigation.pois | transloco }}</p>
  <div class="pois">
    @for (poi of pois(); track poi.qrCodeId) {
      <cue-poi
        [link]="links()"
        [poi]="poi"
        [selected]="poi.qrCodeId === selectedQrCodeId()"
        (click)="poiClicked.emit(poi)"
      />
    }
  </div>
}
